import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { VideoIcon, FileTextIcon, LayersIcon, MessageCircleIcon, CheckIcon } from 'lucide-react';
const CORE = [{
  icon: VideoIcon,
  title: '12 sesiones individuales con Mati',
  desc: 'Una por semana, ~55 minutos. Trabajo real sobre lo que vos estás viviendo, no sobre un temario.'
}, {
  icon: FileTextIcon,
  title: 'Material semanal personalizado',
  desc: 'Documentos y ejercicios adaptados a tu proceso. No plantillas genéricas.'
}, {
  icon: LayersIcon,
  title: 'Los 5 pilares integrados',
  desc: 'Cuerpo · Mente · Identidad · Familia · Propósito, todos conectados en progresión.'
}, {
  icon: MessageCircleIcon,
  title: 'Acceso directo por WhatsApp',
  desc: 'Durante todo el programa. Para lo que aparezca en la semana, cuando aparezca.'
}];
const VALUE_STACK = [{
  label: '12 sesiones individuales 1 a 1 (~55 min c/u)',
  value: '$2.400'
}, {
  label: 'Material semanal personalizado',
  value: '$400'
}, {
  label: 'Acceso directo por WhatsApp durante todo el programa',
  value: '$300'
}, {
  label: 'Sesión de cierre + Plan de 90 días',
  value: '$200'
}, {
  label: 'Acceso de por vida a todos los materiales',
  value: '$300'
}, {
  label: '1 mes de seguimiento post-programa por WhatsApp',
  value: '$150'
}];
export function IncludesSection() {
  return <section id="includes" className="py-14 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-160" data-mp="h1vmk4kfhi6o">
      <div className="max-w-6xl mx-auto px-6" data-id="element-161" data-mp="m1grcvma4krb">
        <FadeIn className="text-center mb-10 md:mb-16" data-id="element-162" data-mp="m05iwihw2otv">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand mb-4" data-id="element-163" data-mp="7cu8ijxg1avc">
            Qué incluye
          </h2>
          <p className="text-offwhite-dim text-lg" data-id="element-164" data-mp="c9koz8d5u8ha">
            Todo lo necesario para sostener el proceso las 12 semanas.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-165" data-mp="14r6jtc2kkug2">
          {CORE.map((item, i) => {
          const Icon = item.icon;
          return <FadeIn key={item.title} delay={i * 0.08} direction="up" className="bg-charcoal border border-charcoal-light rounded-sm p-6 md:p-8 flex gap-5" data-id="element-166" data-mp="1emng4zm34ihq" data-mpi={i}>
                <div className="bg-charcoal-dark p-3 rounded-sm border border-charcoal-light h-fit shrink-0" data-id="element-167" data-mp="10nxjfl36gktw">
                  <Icon className="w-6 h-6 text-sand" data-id="element-168" data-mp="vp2stwyyxrz8" />
                </div>
                <div data-id="element-169" data-mp="qxuhgve2vwjf">
                  <h3 className="text-lg font-heading font-bold text-offwhite mb-2 leading-snug" data-id="element-170" data-mp="qxcc999fu7zd">
                    {item.title}
                  </h3>
                  <p className="text-offwhite-dim text-sm md:text-base leading-relaxed" data-id="element-171" data-mp="lwoocwgia79d">
                    {item.desc}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>

        {/* VALUE STACK */}
        <FadeIn delay={0.2} className="mt-8 md:mt-12" data-id="element-172" data-mp="7yqbxwlqwkwi">
          <div className="bg-charcoal border border-sand/30 rounded-sm p-6 md:p-10 max-w-3xl mx-auto" data-id="element-173" data-mp="81cibswwgud5">
            <h3 className="text-lg font-heading font-bold text-offwhite uppercase tracking-wider mb-6 md:mb-8" data-id="element-174" data-mp="2joob4ou3ogcg">
              El valor de lo que recibís
            </h3>

            <ul className="space-y-4" data-id="element-175" data-mp="2snjnkinqmmo7">
              {VALUE_STACK.map(item => <li key={item.label} className="flex items-start justify-between gap-4 pb-4 border-b border-charcoal-light" data-id="element-176" data-mp="2xktk0i9jnylj">
                  <span className="flex items-start gap-3 text-offwhite-dim" data-id="element-177" data-mp="24wnyhtao25kn">
                    <CheckIcon className="w-5 h-5 text-sand shrink-0 mt-0.5" data-id="element-178" data-mp="29wsd1ds0kq88" />
                    {item.label}
                  </span>
                  <span className="font-heading font-medium text-offwhite-dim/70 shrink-0" data-id="element-179" data-mp="2eo0pkion4rpm">
                    Valor {item.value}
                  </span>
                </li>)}
            </ul>

            <div className="mt-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6" data-id="element-180" data-mp="1m5d7lc4xxssr">
              <div data-id="element-181" data-mp="3ou4q9vancdfg">
                <p className="text-xs text-offwhite-dim/60 uppercase tracking-[0.2em]" data-id="element-182" data-mp="3orilu4j1ye1g">
                  Valor total
                </p>
                <p className="mt-1 text-2xl font-heading font-bold text-offwhite-dim line-through decoration-amber/60" data-id="element-183" data-mp="1h2h8jf9zs53">
                  $3.750
                </p>
              </div>
              <div className="sm:text-right" data-id="element-184" data-mp="beqdxewfz9pw">
                <p className="text-xs text-sand uppercase tracking-[0.2em]" data-id="element-185" data-mp="bdf5v2vyrfsz">
                  Tu inversión hoy · grupo fundador
                </p>
                <p className="mt-1 text-4xl md:text-5xl font-heading font-bold text-sand" data-id="element-186" data-mp="kfen9waw4lwg">
                  $1.200
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}